import React from 'react';

const SOURCES = [
  { key: 'cloudtrail', label: 'CloudTrail' },
  { key: 'config', label: 'Config' },
  { key: 'inspector', label: 'Inspector' },
  { key: 'macie', label: 'Macie' },
  { key: 'purview', label: 'Purview' },
];

export default function CoverageSourcePills({ active = ['cloudtrail', 'config', 'inspector', 'macie'], className = '' }) {
  const set = new Set(active);
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="coverage-pills">
      {SOURCES.map((s) => {
        const on = set.has(s.key);
        return (
          <span
            key={s.key}
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-mono uppercase rounded-full border ${on ? 'bg-emerald-50 text-apex-success border-emerald-200' : 'bg-slate-50 text-slate-400 border-slate-200'}`}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${on ? 'bg-apex-success' : 'bg-slate-300'}`} />
            {s.label}
          </span>
        );
      })}
    </div>
  );
}
